import { Plus, Settings } from "lucide-react";
import React from "react";

const PageHeader = ({
  children,
  title = "",
  text = [],
  buttonTitle = "",
  handleClick = () => { },
  showBtn2 = false,
  handleBtn2Click = () => { },
  disableBtn2 = true,
  buttonTitle2 = "",
}) => {
  return (
    // <div className="p-6">
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-green-600 transition duration-300 ease-in-out hover:text-green-800">
          {title}
        </h1>
        <div className="mt-4 space-y-2 text-gray-600">
          {text?.map((item, i) => (
            <p key={i}>{item}</p>
          ))}
        </div>
      </div>

      {buttonTitle ? (
        <div className="flex gap-2 items-center ml-2">
          <button
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
            onClick={() => handleClick()}
            title={buttonTitle}
          >
            <Plus size={20} />
            {buttonTitle}
          </button>
          {showBtn2 ?
            <button
            className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-lg
                       flex items-center gap-2 transition-all shadow-md hover:shadow-lg
                       transform hover:-translate-y-0.5
                       disabled:bg-gray-400 disabled:cursor-not-allowed
                       disabled:hover:shadow-md disabled:hover:-translate-y-0"
            onClick={()=> handleBtn2Click()}
            disabled={disableBtn2}
            title={buttonTitle2}
          >
              <Settings size={20} />
            </button> : <></>}
        </div>
      ) : (
        <></>
      )}

      <div className="bg-gray-200 h-0.5 m-1"></div>
      {children}
    </div>
    // </div>
  );
};

export default PageHeader;
